import React from 'react'

const SvgSignature = () => {
  return (
    <svg viewBox="0 0 100 100">
      <g fill="none" stroke="#4D6B96" strokeWidth="3" strokeMiterlimit="1" >
        <path d="M4.4 58.9C5.2 48.7 6.9 43.7 8.9 38c2.4-6.9 5-11.5 6.8-11.1s-1.8 27.9-6.5 45.6c1.9-9.8 4.5-19.4 6.6-29.2 1-4.6 2-9.2 3.1-13.8.9-3.6 3-13.2 4.6-13.3 2.1-.2-4.5 34.9-8.3 52.1 3.1-18.5 13.1-53.9 16.4-53.9 4.5 0-14.6 60.8-15.5 64.3s-3.2 12 2 13.8"/>
        <path d="M27 55.7c-1.2 3.7-5.4 15.2-.9 15.6 5.3.5 13.6-27.4 8.6-27.9-5.6-.5-12.2 24.2-8.2 25.3"/>
        <path d="M43.9 44.4c-2.2 2.6-13.7 24.9-6 25.1 6.4.2 6.8-26.9 6.8-26.9s1 18.8 4.3 27.6"/>
        <path d="M50.3 46.3c-.2 2.8-1.8 19.2 1.7 20.1 1.3-7.5-2.6-15-1.1-22.5.7-3.3 2.3-6.2 4.3-8.8.1-.2 5-5.7 5.3-3.6-.4-.2-.8-.3-1.1-.5"/>
        <path d="M58.2 40.9c-1.5 6.9-4.8 19.3-1.3 26 3.4-.7 5.1-15.4 5.6-18-2.3 7.3-3.2 14.9-2.7 22.5.5.1.9.2 1.4.4 7.1-8.6 7.2-29.2 4.6-39.3-.9 1.9-1.2 4-.8 6.1"/>
        <path d="M70.9 41.8c.4-1.5 1.3-2.9 2.6-3.8-1.2 9.7-2.4 19.4-3.7 29.2 1.8.1 3.5-1.7 3.3-3.5"/>
        <path d="M72.2 29.7c5.9 1.4 10.2-14.2 2.2-11.4-2.4.8-4.8 5.6-4.2 7.9 1.1 4.2 5.7 2.1 5.5 1.9"/>
        <path d="M81.8 52.8c.1-2.2.5-7.9-2.8-7.8-3.1.1-3.9 10.6-4 12.6-.2 2.6-.9 9.1 1.7 10.9 3.6 2.5 6-1.8 7.4-5"/>
        <path d="M84.9 60.5c1.8-14.1 2.7-28.3 2.9-42.4.4.3 1.5 1.5 1.1 3.1"/>
        <path d="M86.8 41.6c.5 6.5 3.9 15.7 7.6 21.1"/>
        <path d="M94.3 35.1c-1.7 5-3.9 9.9-6.6 14.4"/>
        <path d="M9.3 82.8c-3.3-5.8 9-4.2 16.1-3 7.5 1.2 14.9 2.8 22.6 3.4 11.2.9 33.9 2.7 41-8.7"/>
      </g>
    </svg>
  )
}

export default SvgSignature
